export const CONNECTED = 'CONNECTED';
export const CHATFLOW_DELETED = 'CHATFLOW_DELETED';
export const DISCONNECTED = 'DISCONNECTED';